// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2198":"97d29036","3497":"97d29036","7023":"97d29036"}[chunkId] + ".chunk.css";
};